module.exports = __webpack_public_path__ + "img/pageIndex_bg.7b35fb90.png";